__turbopack_context__.v({
  "loader": "pageloader-module-scss-module__3o1sGW__loader",
  "loading": "pageloader-module-scss-module__3o1sGW__loading",
});
